<script>
  import { onMount } from 'svelte'
  export let item
  export let base

  onMount(async () => {
    var slider = tns({
      container: '#carousel-' + item.id,
      items: 1,
      slideBy: 'page',
      autoplay: false,
      nav: false,
      controlsText: [
        '<span class="carousel-control-prev-icon" aria-hidden="true"></span>',
        '<span class="carousel-control-next-icon" aria-hidden="true"></span>',
      ],
    })
  })
</script>

<div class="container pad">

  <div class="text-center intro mb-5">
    <h1>
      {#if item.title}{item.title}{:else}Carousel{/if}
    </h1>
    <p>
      {@html item.body}
    </p>
  </div>

  <div class="row">

    <div class="col-md-2" />
    <div class="col-md-8">

      <div class="sf-carousel" id="carousel-{item.id}">

        {#if item.images.length}
          {#each item.images as img}
            <div>
              <img src={img.url} class="img-fluid" alt="gallery" />
            </div>
          {/each}
        {:else}
          <div>
            <img
              src="{base}themes/PlayFair/img/gal1.jpg"
              class="img-fluid"
              alt="placeholder" />
          </div>
          <div>
            <img
              src="{base}themes/PlayFair/img/gal2.jpg"
              class="img-fluid"
              alt="placeholder" />
          </div>
          <div>
            <img
              src="{base}themes/PlayFair/img/gal3.jpg"
              class="img-fluid"
              alt="placeholder" />
          </div>
        {/if}

      </div>
      <div class="col-md-2" />

    </div>
  </div>
</div>
